module.exports = __webpack_public_path__ + "static/media/testata.b7e55ae2.png";